import React from 'react';

import FormattedTimeZone from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import type { MarketType } from '@swf/generated/types/api/sports';
import type { EventTypeId } from '@swf/sports/types/eventType';
import { isHorseRacing } from '@swf/sports/utils/isEventTypeId';

interface Props {
  className?: string;
  eventTypeId?: EventTypeId;
  description?: string;
  venue?: string;
  marketTime?: string;
  marketType?: MarketType;
}

export const OpportunityDescription: React.FC<Props> = ({
  className,
  eventTypeId,
  description,
  venue,
  marketTime,
  marketType
}) => {
  if (isHorseRacing(eventTypeId) && marketTime && marketType !== 'ANTEPOST_WIN') {
    return (
      <span className={className}>
        {venue}
        {' - '}
        <FormattedTimeZone hour="2-digit" minute="2-digit" hour12={false} date={marketTime} />
      </span>
    );
  }

  if (description) {
    return <span className={className}>{description}</span>;
  }

  return null;
};
